module.exports = __webpack_public_path__ + "img/chevron-right-32x32.5e1ccbce.svg";